import { render, staticRenderFns } from "./AssessmentCentreListing.vue?vue&type=template&id=24e299a5"
import script from "./AssessmentCentreListing.vue?vue&type=script&lang=js"
export * from "./AssessmentCentreListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports